import {
  numCol,
  intCol,
  strCol,
  dateTimeCol,
} from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  modifiedDateCol,
  modifierCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { monthMapChoiceWithId } from 'core/utils'
import { unitHeader } from '../../core/HeaderColTypeProps'

export const SppAcaUnitTypesHeaders = [
  strCol({
    ident: 'sppUnittype',
    display: 'SPP Unit Type',
    isKey: true,
    sortOrder: 'asc',
    width: 400,
    alignment: 'left',
    ellipsis: true,
  }),

  modifierCol,
  modifiedDateCol,
]

export const SppAcaUnitsHeaders = [
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'sppUnittype',
    display: 'SPP Unit Type',
    // isKey: true,
    isRequired: true,
    sortOrder: 'asc',
    width: 400,
    ellipsis: true,
    alignment: 'left',
  }),

  modifierCol,
  modifiedDateCol,
]

export const SppAcaUnitsCapabilityHeaders = [
  { ...utilityHeader, isFormat: true },
  unitIdHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'asc' }),
  strCol({
    ident: 'season',
    display: 'Season',
    isKey: true,
    sortOrder: 'asc',
    ...toSelectionColProps(['Summer', 'Winter']),
  }),
  numCol({
    ident: 'verifiedCapacity',
    display: 'Verified Capacity',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),

  modifierCol,
  modifiedDateCol,
]

export const SppAcaUnitsCapabilityHeadersExport = [
  { ...unitIdHeader, display: 'Unit Name', ident: 'unitName' },
  { ...utilityHeader, isFormat: false },
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'asc' }),
  numCol({
    ident: 'verifiedCapacity',
    display: 'Verified Capacity',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),

  modifierCol,
  modifiedDateCol,
]

export const SppAcaUnitsCapabilityExportHeaders = [
  utilityHeader,
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'asc' }),
  numCol({
    ident: 'verifiedCapacity',
    display: 'Verified Capacity',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),

  modifierCol,
  modifiedDateCol,
]

export const SppAcaParametersHeaders = [
  intCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'desc' }),
  numCol({
    ident: 'incrementalOutageImpact',
    display: 'Incremental Outage Impact',
    isRequired: true,
    sortOrder: 'asc',
    width: 250,
  }),
  numCol({
    ident: 'totalSystemEfofImpact',
    display: 'Total System EFOF Impact',
    isRequired: true,
    sortOrder: 'asc',
    width: 250,
  }),

  modifierCol,
  modifiedDateCol,
]

export const SppAcaClassAvgHeaders = [
  intCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'desc' }),
  strCol({
    ident: 'sppUnittype',
    display: 'SPP Unit Type',
    isKey: true,
    sortOrder: 'asc',
    width: 300,
    ellipsis: true,
    alignment: 'left',
  }),

  strCol({
    ident: 'season',
    display: 'Season',
    isKey: true,
    sortOrder: 'asc',
    ...toSelectionColProps(['Summer', 'Winter']),
  }),
  numCol({
    ident: 'classAvgEford',
    display: 'Class Average EFORd',
    isRequired: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'classAvgEfof',
    display: 'Class Average EFOF',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),

  modifierCol,
  modifiedDateCol,
]

export const SppAcaNotExcCausecodeHeaders = [
  intCol({
    ident: 'causecode',
    display: 'Cause Code',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),

  strCol({
    ident: 'description',
    display: 'Cause Code Description',
    // isKey: true,
    sortOrder: 'asc',
    width: 700,
    ellipsis: true,
    alignment: 'left',
  }),

  modifierCol,
  modifiedDateCol,
]

export const SppAcaSeasonHeaders = [
  intCol({
    ident: 'effectiveYear',
    display: 'Effective Year',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  intCol({
    ident: 'summerStartMonth',
    display: 'Summer Start Month',
    isFiltered: true,
    sortOrder: 'asc',
    ...monthMapChoiceWithId,
    width: 200,
  }),
  intCol({
    ident: 'summerEndMonth',
    display: 'Summer End Month',
    isFiltered: true,
    sortOrder: 'asc',
    ...monthMapChoiceWithId,
    width: 200,
  }),
  intCol({
    ident: 'winterStartMonth',
    display: 'Winter Start Month',
    isFiltered: true,
    sortOrder: 'asc',
    ...monthMapChoiceWithId,
    width: 200,
  }),
  intCol({
    ident: 'winterEndMonth',
    display: 'Winter End Month',
    isFiltered: true,
    sortOrder: 'asc',
    ...monthMapChoiceWithId,
    width: 200,
  }),

  modifierCol,
  modifiedDateCol,
]

export const SppAcaAnplhHeaders = [
  dateTimeCol({
    ident: 'anplh',
    display: 'ANPLH',
    isKey: true,
    sortOrder: 'desc',
    width: 200,
    displayFormat: 'MM/DD/YYYY HH',
  }),

  modifierCol,
  modifiedDateCol,
]
